export default __webpack_public_path__ + "static/cardImg2-8ffe6972ca9e6ebc63cd655a2a7d2151.webp";